// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
const currentYear = siteData.current_year
const logoTextPNG = siteData.images_url + 'logo/atsim-logo.png'

class Footer extends React.Component {
	render() {
		return (
			<footer className="footer">
				<div className="-inner">
					<div className="-social">
						<p>
							<a className="plain" href="https://www.facebook.com/atsimau" target="_blank">
								<span>Follow us on facebook</span> <img src={ `${siteData.images_url}icons/facebook-mono.svg` } alt="Facebook" />
							</a>
						</p>
					</div>

					<div className="-a">
						<p>
							P.O. Box 4368, Ringwood VIC 3134, Australia
						</p>

						<p>
							Copyright &copy; { currentYear } ATSIM
							<br />
							Website by <a className="plain" href="https://alexgreendesign.com" target="_blank">Alex Green Design</a>
						</p>
					</div>
				</div>
			</footer>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Footer )



// WEBPACK FOOTER //
// ./components/Footer/Footer.jsx